export default {
  title: "Reject Issue",
  content:
    "<div>This marks the <b class='text-info'>Issue</b> as rejected and closes it.<br><br>" +
    "Rejection of <b class='text-info'>Issues</b> conveys not only that the <b class='text-info'>Issue</b> will not be Corrected, but that the <b class='text-info'>Issue</b> should not have been raised at all.<br><br>" +
    "The <b class='text-info'>Issue</b> will not be included by default in the <b class='text-info'>Issues</b> lists and will not be counted in the statistics for its related object.<br><br>" +
    "Related un-reviewed <b class='text-info'>Performed Corrective Work</b> will be closed.<br><br>" +
    "<b class='text-info'>Issue</b> rejection <b class='text-negative text-uppercase'>cannot</b> be undone!<br><br>" +
    "Are you sure you want to proceed?</div>",
  input_label: "Reasoning",
}
